
export async function pollUntil(predicateFn, {
  timeoutMs = 20000,
  minDelayMs = 300,
  maxDelayMs = 2500,
  factor = 1.7
} = {}) {
  const start = Date.now();
  let delay = minDelayMs;

  const forever = true;
  while (forever) {
    const ok = await safePredicate(predicateFn);
    if (ok) return true;

    const elapsed = Date.now() - start;
    if (elapsed >= timeoutMs) return false;

    await sleep(delay);
    delay = Math.min(Math.floor(delay * factor), maxDelayMs);
  }
  return false;
}

function sleep(ms) { return new Promise(res => setTimeout(res, ms)); }

async function safePredicate(fn) {
  try {
    return await fn();
  } catch (e) {
    // Swallow transient errors during polling; log if needed
    console.warn('poll predicate error:', e);
    return false;
  }
}
